import { render, staticRenderFns } from "./TempBienBan.vue?vue&type=template&id=299bbef7&scoped=true"
import script from "./TempBienBan.vue?vue&type=script&lang=js"
export * from "./TempBienBan.vue?vue&type=script&lang=js"
import style0 from "./TempBienBan.vue?vue&type=style&index=0&id=299bbef7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299bbef7",
  null
  
)

export default component.exports